'use strict';
angular.module('schoolLinqApp').directive('allowedPattern', [
	'$filter',
	'$browser',
	function ($filter, $browser) {
		return {
			require: 'ngModel',
			link: function ($scope, $element, $attrs, ngModelCtrl) {
				ngModelCtrl.$parsers.push(function (inputValue) {
					var allowedReg = new RegExp($attrs.allowedPattern);
					var transformedInput;

					if (!(inputValue === null || typeof inputValue === 'undefined')) {
						transformedInput = _.filter(inputValue.toString().split(''), function (char) {
							return allowedReg.test(char);
						}).join('');
					}

					if (transformedInput != inputValue) {
						// NOTE: must keep comparison operator '!=' instead of '!=='
						ngModelCtrl.$setViewValue(transformedInput);
						ngModelCtrl.$render();
					}

					return transformedInput;
				});
			},
		};
	},
]);
